import React from "react";
import { hydrate } from "react-dom";
import merge from 'lodash/merge';
import { officeCalculatorConfig } from '~configs/calculator';
import OfficeCalculator from '~components/OfficeCalculator';

const CalcEntry = ({ config }) => {
  return (<OfficeCalculator config={merge(officeCalculatorConfig, config)} />)
};

if (typeof window['RC_APPS'] !== 'object') window['RC_APPS'] = {};

window['RC_APPS']['calc'] = (container, widgetProps) => {
  hydrate(CalcEntry(widgetProps), container);
};

if (module.hot) {
  module.hot.accept();
}
